import React from "react";
import './QualificationDropdown.css'; // Make sure to create and import this CSS file

const EmpLoymentQuestionDropdown = ({ label, options, onChange, selected, catchIfAllStatusInComplete, currentSavedEmploymentStatus, isDisableEmpQuestion }) => {
  console.log("selected...",selected)
  return (
    <div className="form-group">
      <div className="floating-label tp-dropdown">
        <select 
        className="form-control" 
        onChange={onChange} 
        // disabled={!catchIfAllStatusInComplete && currentSavedEmploymentStatus > 0}
        disabled={isDisableEmpQuestion}>
          <option value="" disabled selected={selected === 0 ? true : false} >Select option</option>
          {options.map((option, index) => (
            <option
              key={index}
              value={option?.id}
              selected={selected == option?.id ? true : false}
              title={option?.options} // Tooltip for full text
            >
              {/* {(option?.options).length > 36 ? (option?.options).substring(0, 36) + '...' : option?.options} */}
              {/* {selected === option?.id ? '✓ ' : ''} */}
              {option?.options}
            </option>
          ))}
        </select>
        <label className="focused">
          {label} <sup className="text-danger">*</sup>
        </label>
      </div>
      <p className="err text-danger"></p>
      <input type="hidden" />
    </div>
  );
};

export default EmpLoymentQuestionDropdown;